module.exports = __webpack_public_path__ + "img/08 Animation 2-squashed.faebdd27.jpg";